export default "__VITE_ASSET__Bk5dw$0U__"